"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunk5423f15f = require("./chunk-5423f15f.js");

var _MultiSelectMenuList = _interopRequireDefault(require("./MultiSelectMenuList.js"));

require("./chunk-76875e58.js");

require("./chunk-f2932d1d.js");

require("react");

require("prop-types");

require("./chunk-8219403d.js");

require("./chunk-eb19ede6.js");

require("react-dom");

require("./chunk-5ef88ed1.js");

require("./chunk-b2edacfb.js");

require("./MultiSelectOption.js");

require("styled-components");

require("classnames");

require("./CheckboxIndicator.js");

require("./CFontIcon.js");

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-cb015231.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuList = function MenuList(props) {
  return props.selectProps.isMulti ? (0, _MultiSelectMenuList.default)(props) : _chunk5423f15f.a.MenuList(props);
};

var _default = MenuList;
exports.default = _default;